import BaseService from './baseService';

class MailingListService {
    static subscribe(email, articleType = null) {
        return BaseService.postAndReturn('/MailingList', { email, articleType }, (data) => data, null, true);
    } 
}
export default MailingListService;